import React from 'react';
import { Linkedin } from 'lucide-react';
import { contactData } from '../mock';

const iconMap = {
  linkedin: Linkedin
};

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_hvac-solutions-25/artifacts/q5ko5jaq_averonlogo.png"
                alt="Averon"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-gray-400 leading-relaxed">
              Sənaye və kommersiya obyektləri üçün steam trap management, HVAC, quraşdırma və texniki xidmət həlləri.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Sürətli Keçidlər</h3>
            <ul className="space-y-2">
              <li>
                <a href="#home" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Əsas səhifə
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Xidmətlərimiz
                </a>
              </li>
              <li>
                <a href="#about" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Haqqımızda
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Əlaqə
                </a>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h3 className="text-lg font-bold mb-4">Əlaqə</h3>
            <div className="space-y-2 mb-4">
              <p className="text-gray-400">{contactData.email}</p>
              <p className="text-gray-400">{contactData.phone}</p>
              <p className="text-gray-400">{contactData.address}</p>
            </div>
            <div className="flex space-x-4">
              {contactData.socialMedia.map((social) => {
                const IconComponent = iconMap[social.icon];
                return (
                  <a
                    key={social.name}
                    href={social.url}
                    className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gradient-to-br hover:from-blue-500 hover:to-cyan-400 transition-all duration-300 hover:scale-110"
                    aria-label={social.name}
                  >
                    {IconComponent && <IconComponent size={20} />}
                  </a>
                );
              })}
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400">
            &copy; {currentYear} Averon MMC. Bütün hüquqlar qorunur.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
